let order = require('./order.json');
let tagMap = require('./tagMap.json');

module.exports = {order, tagMap};